import { render, staticRenderFns } from "./noticeConfig.vue?vue&type=template&id=30fb8067&"
import script from "./noticeConfig.vue?vue&type=script&lang=js&"
export * from "./noticeConfig.vue?vue&type=script&lang=js&"
import style0 from "./noticeConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports